const getInvoicesIsLoading = state => state.debtor.invoices.loading;

export default getInvoicesIsLoading;
